// eslint-disable-next-line import/no-anonymous-default-export
export default {
    azulClaro: '#2980b9',
    vermelho: '#C23616',
    amarelo: '#e1b12c'
}